import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AbstractModal } from '../AbstractModal';
import { CompanySettings } from '../../../../settings/model/company-settings';
import { ModalService } from '../modal.service';
import { Subject, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromCompanySettingsStore from '../../../../settings/store';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ls-giftcard-settings',
  templateUrl: './giftcard-settings.component.html'
})
export class GiftcardSettingsComponent extends AbstractModal
  implements OnInit, OnDestroy {
  public loading = true;
  public form: FormGroup;

  private companySettings: CompanySettings = null;
  private ngUnsubscribe: Subject<Subscription> = new Subject();

  constructor(
    private modal: ModalService,
    private fb: FormBuilder,
    private store: Store<fromCompanySettingsStore.CompanyState>
  ) {
    super();
  }

  public ngOnInit(): void {
    fromCompanySettingsStore
      .getSettingsFromStore(this.store)
      .pipe(
        map((settings: CompanySettings) => {
          this.companySettings = Object.assign({ ...settings });
          const expiryMonths: number = this.companySettings
            .customerCardExpiryMonths;
          this.loading = false;
          this.form = this.fb.group({
            expiryDateEnabled: expiryMonths > 0,
            expiryMonths: [{ value: expiryMonths, disabled: expiryMonths <= 0 }]
          });

          this.form.valueChanges.subscribe((data: any) => {
            if (data.expiryDateEnabled) {
              this.form.get('expiryMonths').enable({ onlySelf: true });
            } else {
              this.form.get('expiryMonths').disable({ onlySelf: true });
            }
          });
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public close(): void {
    this.modal.close();
  }

  public save(): void {
    let numberOfMonths: number;
    if (!this.form.get('expiryDateEnabled').value) {
      numberOfMonths = 0;
    } else {
      numberOfMonths = this.form.get('expiryMonths').value;
    }
    this.companySettings.customerCardExpiryMonths = numberOfMonths;
    this.store.dispatch(
      new fromCompanySettingsStore.SaveCompanySettings({
        settings: this.companySettings
      })
    );
    this.close();
  }
}
